// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  transition: background-color 0.5s;
}

body {
  background-clip: content-box;
}

#root {
  height: 100%;
}
.app-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.toolbar {
  height: 40px;
  transition: background-color 0.5s;
  display: flex;
  justify-content: space-between;
}

.toolbar-right-box {
  display: flex;
  flex-direction: row-reverse;
}

.sidebar {
  overflow: hidden;
  /*transition: all 0.5s;*/
}

.chart-container {
  display: flex;
  flex: auto;
}

.chart {

}

.toolbar-chart-icon .toolbar-chart-item {
  display: none;
}

.footer {
  height: 35px !important;
  transition: background-color 0.5s;
}


.timeframe-menu-root {
  height: 30px !important;
  background: transparent !important;;
}

.timeframe-menu-root .MuiButtonBase-root {
  min-width: 60px;
  max-width: 60px;
}

.MuiSelect-select,
.timeframe-menu-root .MuiBottomNavigationAction-label {
  font-size: 12px !important;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.toolbar-select .MuiSelect-select {
  padding: 2px 5px;
}

.toolbar-select fieldset {
  border: 0;
}

.change-theme-switch svg {
  background: black;
  border-radius: 20px;
}

.change-theme-switch-checked svg {
  background: #fff;
}

.change-theme-switch .MuiButtonBase-root {
  padding: 7px;
}

.react-financial-charts-enable-interaction {
  cursor: pointer;
  fill: rgba(0, 0, 0, 0);
  stroke: #d9d9d9;
}
.react-financial-charts-enable-interaction:hover {
  fill: rgba(144, 202, 249, 0.35);
  stroke: #2976b5;
}
.element:hover{
  cursor: pointer;
  background-color: #898c8d;
}

button:focus { outline: none !important;}

.small-toggle-button .MuiSvgIcon-root {
  font-size: 1.3rem;
}

.loader-wrapper {
  position: absolute;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.54);
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
}

.error-message {
  font-size: 24px;
  color: white;
  background-color: #972323d4;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  max-width: 40%;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;;AAEA;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;;AAGA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,eAAe,wBAAwB,CAAC;;AAExC;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB","sourcesContent":["html, body {\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  transition: background-color 0.5s;\r\n}\r\n\r\nbody {\r\n  background-clip: content-box;\r\n}\r\n\r\n#root {\r\n  height: 100%;\r\n}\r\n.app-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.toolbar {\r\n  height: 40px;\r\n  transition: background-color 0.5s;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.toolbar-right-box {\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n}\r\n\r\n.sidebar {\r\n  overflow: hidden;\r\n  /*transition: all 0.5s;*/\r\n}\r\n\r\n.chart-container {\r\n  display: flex;\r\n  flex: auto;\r\n}\r\n\r\n.chart {\r\n\r\n}\r\n\r\n.toolbar-chart-icon .toolbar-chart-item {\r\n  display: none;\r\n}\r\n\r\n.footer {\r\n  height: 35px !important;\r\n  transition: background-color 0.5s;\r\n}\r\n\r\n\r\n.timeframe-menu-root {\r\n  height: 30px !important;\r\n  background: transparent !important;;\r\n}\r\n\r\n.timeframe-menu-root .MuiButtonBase-root {\r\n  min-width: 60px;\r\n  max-width: 60px;\r\n}\r\n\r\n.MuiSelect-select,\r\n.timeframe-menu-root .MuiBottomNavigationAction-label {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.toolbar-select .MuiSelect-select {\r\n  padding: 2px 5px;\r\n}\r\n\r\n.toolbar-select fieldset {\r\n  border: 0;\r\n}\r\n\r\n.change-theme-switch svg {\r\n  background: black;\r\n  border-radius: 20px;\r\n}\r\n\r\n.change-theme-switch-checked svg {\r\n  background: #fff;\r\n}\r\n\r\n.change-theme-switch .MuiButtonBase-root {\r\n  padding: 7px;\r\n}\r\n\r\n.react-financial-charts-enable-interaction {\r\n  cursor: pointer;\r\n  fill: rgba(0, 0, 0, 0);\r\n  stroke: #d9d9d9;\r\n}\r\n.react-financial-charts-enable-interaction:hover {\r\n  fill: rgba(144, 202, 249, 0.35);\r\n  stroke: #2976b5;\r\n}\r\n.element:hover{\r\n  cursor: pointer;\r\n  background-color: #898c8d;\r\n}\r\n\r\nbutton:focus { outline: none !important;}\r\n\r\n.small-toggle-button .MuiSvgIcon-root {\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.loader-wrapper {\r\n  position: absolute;\r\n  z-index: 9;\r\n  background-color: rgba(0, 0, 0, 0.54);\r\n  display: flex;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  justify-content: center;\r\n}\r\n\r\n.error-message {\r\n  font-size: 24px;\r\n  color: white;\r\n  background-color: #972323d4;\r\n  padding: 20px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n  max-width: 40%;\r\n  margin: 0 auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
